import React, { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Tooltip, OverlayTrigger, Button, Badge } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import swal from "sweetalert2";
import axios from 'axios';
import AddPurchase from '../../../modal/Purchase_Management/Manage_Purchase/AddRawmaterial';

const AutoPurchase = () => {

  const BaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [selectedOption, setSelectedOption] = useState(null);
  const [purchaseDate, setPurchaseDate] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [vendor, setVendorList] = useState([]);
  const [rawMaterials, setRawmaterials] = useState([]);
  const [unitsMap, setUnitsMap] = useState({});
  const [vendorMaterials, setVendorMaterials] = useState({});
  const [errors, setErrors] = useState({});
  const [checkedRows, setCheckedRows] = useState({});

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const dayAfterTomorrow = new Date(today);
  dayAfterTomorrow.setDate(today.getDate() + 2);


  const [staff, setStaffOptions] = useState([]);
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (show) {
      axios.get(`${BaseUrl}/active-staff`)
        .then(res => {
          // Format: { value: index, label: staff.name }
          const options = res.data.data.map((s, index) => ({
            value: index,
            label: s.name,
          }));
          setStaffOptions(options);
        })
        .catch(err => {
          console.error("Failed to fetch staff list", err);
        });
    }
  }, [show]);


  useEffect(() => {
    fetch(`${BaseUrl}/managevendor/vendors/active`)
      .then((res) => res.json())
      .then((data) => {
        if (data.vendors) {
          const options = data.vendors.map((vendor) => ({
            value: vendor.sno,
            label: vendor.vendor_businessname,
          }));
          setVendorList(options);
        }
      })
      .catch((err) => console.error("Error fetching vendors:", err));
  }, [BaseUrl]);

  const fetchRawMaterials = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/autopurchase/list`);
      if (response.data) {
        const materials = response.data;
        setRawmaterials(materials);

        // Fetch units only for category 8
        const unitsData = {};
        try {
          const res = await axios.get(`${BaseUrl}/manageunit/by-category`, {
            params: { unit_category_sno: 8 }, // fixed category 8
          });
          if (res.data.success) {
            const units = res.data.data.map((unit) => ({
              value: unit.unit_name,
              label: unit.unitslug_name,
            }));
            // Assign same units to all materials
            materials.forEach((material) => {
              unitsData[material.unit_id] = units;
            });
          }
        } catch (err) {
          console.error('Failed to fetch units for category 8', err);
        }

        setUnitsMap(unitsData);
      } else {
        setRawmaterials([]);
      }
    } catch (error) {
      console.error('❌ Failed to fetch Raw Materials:', error);
      setRawmaterials([]);
    }
  };

  useEffect(() => {
    fetchRawMaterials();
  }, []);


  const materialsByVendor = vendor.reduce((acc, vendor) => {
    const vendorIdStr = vendor.value.toString();
    const filteredMaterials = rawMaterials.filter(material => {
      try {
        const vendorIds = JSON.parse(material.vendor || '[]');
        return vendorIds.includes(vendorIdStr);
      } catch (err) {
        console.error('❌ Failed to parse vendor field:', material.vendor);
        return false;
      }
    });

    if (filteredMaterials.length > 0) {
      acc[vendor.value] = {
        name: vendor.label, // use `label` (vendor_businessname), not `name`
        materials: filteredMaterials,
      };
    }

    return acc;
  }, {});



  const Group = (props) => (
    <div style={customStyles}>
      <components.Group {...props} />
    </div>
  );
  const customStyles = {
    groupHeading: (provided) => ({
      ...provided,
      fontSize: '14px',  // Increase the font size for group labels
      fontWeight: 'bold',  // Optional: make the label bold
      color: '#333',  // Optional: change the text color
    }),
  };


  useEffect(() => {
    if (Object.keys(vendorMaterials).length === 0) {
      const copy = {};
      for (const [vendorId, vendorData] of Object.entries(materialsByVendor)) {
        copy[vendorId] = {
          name: vendorData.name,
          materials: vendorData.materials.map(mat => ({ ...mat })),
        };
      }
      setVendorMaterials(copy);
    }
  }, [materialsByVendor, vendorMaterials]);


  // Handler for when base_cost changes
  // Update cost in state (vendorMaterials)
  const handleCostChange = (vendorId, materialIndex, newCost) => {
    setVendorMaterials(prevState => {
      const updated = { ...prevState };
      const materialsCopy = [...updated[vendorId].materials];
      materialsCopy[materialIndex] = {
        ...materialsCopy[materialIndex],
        base_cost: newCost,
      };
      updated[vendorId] = {
        ...updated[vendorId],
        materials: materialsCopy,
      };
      return updated;
    });
  };



  // Sum vendor total cost
  const calcVendorTotal = (vendorId) => {
    return vendorMaterials[vendorId]?.materials.reduce((total, mat) => {
      const cost = parseFloat(mat.base_cost) || 0;
      return total + cost;
    }, 0) || 0;
  };

  // Sum grand total of all vendors
  const calcGrandTotal = () => {
    return Object.values(vendorMaterials).reduce((grandTotal, vendorData) => {
      return (
        grandTotal +
        vendorData.materials.reduce((sum, mat) => sum + (parseFloat(mat.base_cost) || 0), 0)
      );
    }, 0);
  };



  const tableRef = useRef(null);
  useEffect(() => {
    if (tableRef.current) {
      if (!$.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable({
          "responsive": true,
          //   "aaSorting": [],
          "ordering": false,
          "paging": false,
          scrollY: "250px", // Set the scroll height here
          scrollCollapse: true,
          "language": {
            "lengthMenu": "Show _MENU_",
          },
          "dom":
            "<'row'" +
            // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
            // "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
            ">" +
            "<'table-responsive'tr>" +
            "<'row'" +
            // "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
            ">"
        });
      }
    }
  }, []);


  // const ConfirmationModal = () => {
  //     swal.fire({
  //         html: `
  //             <div class="alert alert-success px-2 py-2" role="alert">
  //                 Are You Sure Want to Create Purchase
  //                 <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  //             </div>
  //             <label class="text-center"><b>APF/2025/JAN/PUR1055</b></label>
  //             <div class="text-center">
  //                 <svg xmlns="http://www.w3.org/2000/svg" 
  //                 // viewBox="0 0 48 48" width="48" height="48">
  //                 // <defs>
  //                 // <style>.cls-2{fill:#273941}.cls-5{fill:#f6fafd}
  //                 // </style></defs>
  //                 // <g id="_03-smile" data-name="03-smile"><circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
  //                 // <path class="cls-2" d="M24 39c-7.168 0-13-4.935-13-11h2c0 4.962 4.935 9 11 9s11-4.038 11-9h2c0 6.065-5.832 11-13 11zM20 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6zM38 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6z"/>
  //                 // <path d="M24 4c12.15 0 22 8.507 22 19h.975a23 23 0 0 0-45.95 0H2C2 12.507 11.85 4 24 4z" style="fill:#ffe369"/>
  //                 // <path d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z" style="fill:#ffb32b"/>
  //                 // <ellipse class="cls-5" cx="37" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 37 9)"/>
  //                 // <ellipse class="cls-5" cx="30.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 30.745 4.5)"/>
  //                 // <ellipse class="cls-5" cx="34" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 34 7)"/></g>
  //                 // </svg>
  //             </div>
  //                         `,
  //         showCancelButton: true,
  //         confirmButtonText: 'Yes!',
  //         cancelButtonText: 'No',
  //         reverseButtons: true,
  //         customClass: {
  //             title: 'fs-6',
  //             cancelButton: 'btn btn-sm btn-secondary',
  //             confirmButton: 'btn btn-sm btn-success',
  //             htmlContainer: 'text-left'
  //         },
  //         allowOutsideClick: false,
  //         allowEscapeKey: false,
  //     }).then(() => {
  //         window.location.href = './manage-purchase';
  //     });
  // };


  const validateForm = () => {
    const newErrors = {};


    if (!purchaseDate) {
      newErrors.purchaseDate = "Purchase Date is required";
    } else {
      let selectedDate;
      if (purchaseDate.toDate) {
        selectedDate = purchaseDate.toDate();
      } else {
        selectedDate = new Date(purchaseDate);
      }

      const todayDate = new Date(today.setHours(0, 0, 0, 0));
      const maxDate = new Date(dayAfterTomorrow.setHours(23, 59, 59, 999));

      if (selectedDate < todayDate || selectedDate > maxDate) {
        newErrors.purchaseDate = `Date must be between ${todayDate.toLocaleDateString()} and ${maxDate.toLocaleDateString()}`;
      }
    }


    if (!selectedOption) {
      newErrors.selectedOption = "Please select a staff member";
    }


    let checkedAtLeastOne = Object.keys(checkedRows).length > 0;

    if (!checkedAtLeastOne) {
      newErrors.checkedRows = "Please select at least one item to purchase";
    } else {
      // Validate qty and price for checked rows only
      Object.keys(checkedRows).forEach(key => {
        // key = "vendorId-idx"
        const [vendorId, idxStr] = key.split("-");
        const idx = parseInt(idxStr, 10);

        const qtyInput = document.getElementById(`qty-${vendorId}-${idx}`);
        const priceInput = document.getElementById(`price-${vendorId}-${idx}`);

        const qtyValue = qtyInput?.value.trim();
        const priceValue = priceInput?.value.trim();

        if (!qtyValue || isNaN(qtyValue) || parseFloat(qtyValue) <= 0) {
          newErrors[`qty-${key}`] = "Quantity must be greater than zero";
        }
        if (!priceValue || isNaN(priceValue) || parseFloat(priceValue) <= 0) {
          newErrors[`price-${key}`] = "Estimate cost must be greater than zero";
        }
      });
    }

    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };



  const onGeneratePurchase = (e) => {
    e.preventDefault();

    if (validateForm()) {
      // Prepare data in required structure before showing modal
      const purchaseDateFormatted = purchaseDate ?
        (purchaseDate.toDate ? purchaseDate.toDate().toISOString().split('T')[0] : new Date(purchaseDate).toISOString().split('T')[0])
        : null;

      const dataToSend = [];

      Object.entries(vendorMaterials).forEach(([vendorId, vendorData]) => {
        const rawmaterials = [];

        vendorData.materials.forEach((item, idx) => {
          const key = `${vendorId}-${item.rawmaterials_id}`;

          if (checkedRows[key]) {
            const brandInput = document.getElementById(`brand-${vendorId}-${item.rawmaterials_id}`);
            const qtyInput = document.getElementById(`qty-${vendorId}-${item.rawmaterials_id}`);
            const priceInput = document.getElementById(`price-${vendorId}-${item.rawmaterials_id}`);

            const brand = brandInput ? brandInput.value : "-";
            const actual_quantity = qtyInput ? qtyInput.value : "0";
            const actual_price = priceInput ? priceInput.value : "0";

            const quantityNum = parseFloat(actual_quantity) || 0;
            const unit_id = unitsMap[item.rawmaterials_id]?.[0]?.id || null;
            const total_cost = parseFloat(item.base_cost) || 0;  // Estimated cost (before edit)

            rawmaterials.push({
              raw_material_id: item.rawmaterials_id,
              quantity: quantityNum,
              unit_id,
              brand,
              id: item.id || item.rawmaterials_id,
              total_cost,
              actual_quantity,
              actual_price,
              expiry_date: null // Add if you have expiry date input
            });
          }
        });

        if (rawmaterials.length > 0) {
          const estimated_amount = rawmaterials.reduce((acc, rm) => acc + rm.total_cost, 0);
          const actual_amount = rawmaterials.reduce((acc, rm) => acc + parseFloat(rm.actual_price || 0), 0);

          dataToSend.push({
            vendor_id: parseInt(vendorId),
            purchase_staff_id: selectedOption?.value || null,
            rawmaterials,
            number_of_rawmaterials: rawmaterials.length,
            estimated_amount,
            actual_amount,
            purchase_date: purchaseDateFormatted
          });
        }
      });

      // Pass this prepared data to ConfirmationModal
      ConfirmationModal(dataToSend);
    }
    // else no alert on validation errors
  };

  const ConfirmationModal = async (purchaseData) => {
    // Extract purchase date & staff for display from first vendor entry
    const firstVendor = purchaseData[0] || {};
    const purchaseDateStr = firstVendor.purchase_date ? new Date(firstVendor.purchase_date).toLocaleDateString() : 'N/A';

    const staffName = selectedOption ? selectedOption.label : 'N/A';

    // Flatten all rawmaterials across vendors for display in table
    const selectedItems = purchaseData.flatMap(vendor =>
      vendor.rawmaterials.map(item => ({
        vendorId: vendor.vendor_id,
        materialName: item.brand ? `${item.raw_material_id} (${item.brand})` : item.raw_material_id,
        quantity: item.actual_quantity || item.quantity,
        estimatedCost: item.total_cost,
        actualPrice: parseFloat(item.actual_price) || 0,
        totalCost: (parseFloat(item.actual_price) || 0) * (parseFloat(item.actual_quantity) || 0),
      }))
    );

    const grandTotal = selectedItems.reduce((sum, item) => sum + (item.totalCost || 0), 0);

    // Build HTML table rows for selected items
    const itemsTableRows = selectedItems.map(item => `
    <tr>
      <td>${item.materialName}</td>
      <td>${item.quantity}</td>
      <td>₹${item.estimatedCost.toFixed(2)}</td>
      <td>₹${item.totalCost.toFixed(2)}</td>
    </tr>
  `).join("");

    const htmlContent = `
    <div class="mb-3">
      <strong>Purchase Date:</strong> ${purchaseDateStr}<br/>
      <strong>Staff:</strong> ${staffName}<br/>
      <strong>Total Amount:</strong> ₹${grandTotal.toFixed(2)}
    </div>
    <table class="table table-bordered table-sm">
      <thead>
        <tr>
          <th>Material</th>
          <th>Quantity</th>
          <th>Estimated Cost (per unit)</th>
          <th>Total Cost</th>
        </tr>
      </thead>
      <tbody>
        ${itemsTableRows}
      </tbody>
    </table>
    <div class="alert alert-warning mt-3" role="alert">
      Are you sure you want to create this purchase?
    </div>
  `;

    const result = await swal.fire({
      html: htmlContent,
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No',
      reverseButtons: true,
      customClass: {
        title: 'fs-6',
        cancelButton: 'btn btn-sm btn-secondary',
        confirmButton: 'btn btn-sm btn-success',
        htmlContainer: 'text-left',
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      width: '600px',
    });

    if (result.isConfirmed) {
      try {
        // Send data to API
        const response = await axios.post(`${BaseUrl}/autopurchase/confirm`, purchaseData);
        if (response.data.success) {
          await swal.fire({
            icon: 'success',
            title: 'Purchase Created Successfully!',
            timer: 2000,
            showConfirmButton: false,
          });
          window.location.href = './manage-purchase';
        } else {
          throw new Error(response.data.message || 'Failed to create purchase');
        }
      } catch (error) {
        swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Something went wrong while creating purchase',
        });
      }
    }
  };

  const [modalType, setModalType] = useState("");
  const [open, setOpen] = useState(false);
  const handleModalAdd = () => {
      setModalType("Add");
      setOpen(true);
  };


  return (
    <>
      <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
        <div className='mb-2'>
          <div className="mb-0 px-0">
            <h4 className='breadcrumb-header'>Add Purchase</h4>
          </div>
          <ol className="breadcrumb fs-7">
            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
            <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
            <li className="breadcrumb-item">Purchase Management</li>
            <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
            <li className="breadcrumb-item active"><Link to='/manage-purchase'>Manage Purchase</Link></li>
          </ol>
        </div>
      </div>

      {open && modalType === "Add" && (
          <AddPurchase show={open} onClose={() => setOpen(false)} />
      )}

      <div className="row mb-2">
        <div className="col-lg-3 mb-4">
          <label className="text-black font-w500 fs-7">Purchase Date<span className="required">*</span></label>
          <div className='datepicker-wrapper d-flex'>
            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
            <DatePicker
              placeholder="Select Date"
              value={purchaseDate}
              onChange={setPurchaseDate}
              minDate={today}
              maxDate={dayAfterTomorrow}
              format="DD-MM-YYYY"
            />
          </div>
          {errors.purchaseDate && <div className="text-danger fs-7">{errors.purchaseDate}</div>}
        </div>
        <div className="col-lg-3 mb-4">
          <label className="text-black font-w500 fs-7">Assign Staff<span className="required">*</span></label>
          <Select
            placeholder='Select Staff'
            value={selectedOption}   // controlled value
            onChange={setSelectedOption}  // update on select
            options={staff}
            components={{ Group }}
            styles={customStyles}
          />
          {errors.selectedOption && <div className="text-danger fs-7">{errors.selectedOption}</div>}
        </div>
      </div>
      <div className="scroll-y row" style={{ maxHeight: "500px", overflowY: "auto", paddingRight: "10px" }} >
        {Object.entries(vendorMaterials).map(([vendorId, vendorData], index) => (
          <div key={index} className="mb-5">
            <div className="d-flex justify-content-between align-items-center">
              <label className="text-black font-w500 fs-5 mb-2 d-block">
                {vendorData.name}
              </label>
              <div className="col-lg-6 mb-4 d-flex justify-content-end align-items-end ">
                <button type="button" className="btn btn-sm btn-primary me-3" onClick={handleModalAdd}>
                  <label className="text-white font-w500 fs-5">Add Raw Material</label>
                </button>
              </div>
            </div>

            <div className="card px-3 py-3 mb-3 border border-success bg-success-light rounded">
              <div className="table-responsive">
                <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable mb-0">
                  <thead>
                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                      <th className="min-w-50px text-center"></th>
                      <th className="min-w-150px">Raw Material</th>
                      <th className="min-w-120px text-center">Brand</th>
                      <th className="min-w-100px text-center">Qty & Unit</th>
                      <th className="min-w-120px text-center">Estimate Cost (₹)</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-600 fw-semibold fs-7">
                    {vendorData.materials.map((item, idx) => {
                      const unitsForMaterial = unitsMap[item.rawmaterials_id] || [];
                      const unitLabel = unitsForMaterial.length > 0 ? unitsForMaterial[0].label : "";

                      // Use vendorId from outer scope (passed into this component or function)
                      // Assuming vendorId is defined in your outer map where vendorData is from
                      // Just use the variable vendorId directly here
                      // const vendorId = vendor.id; <-- REMOVE THIS

                      const checkboxKey = `${vendorId}-${item.rawmaterials_id}`;
                      const qtyError = errors[`qty-${vendorId}-${item.rawmaterials_id}`];
                      const priceError = errors[`price-${vendorId}-${item.rawmaterials_id}`];

                      return (
                        <tr key={`${item.rawmaterials_id}-${idx}`}>
                          <td>
                            <input
                              type="checkbox"
                              id={`checkbox-${vendorId}-${item.rawmaterials_id}`}
                              checked={!!checkedRows[checkboxKey]}
                              onChange={(e) => {
                                const newCheckedRows = { ...checkedRows };
                                if (e.target.checked) {
                                  newCheckedRows[checkboxKey] = true;
                                } else {
                                  delete newCheckedRows[checkboxKey];
                                }
                                setCheckedRows(newCheckedRows);
                              }}
                            />
                          </td>
                          <td>
                            <label className="text-black font-w400 fs-7" htmlFor={`checkbox-${vendorId}-${item.rawmaterials_id}`}>
                              {item.rawmaterial_name}
                            </label>
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Brand"
                              defaultValue={item.brand || ""}
                              id={`brand-${vendorId}-${item.rawmaterials_id}`}
                            />
                          </td>
                          <td>
                            <div style={{ position: 'relative', width: '100px', margin: '0 auto' }}>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Qty"
                                defaultValue={item.rawmaterial_qty}
                                style={{
                                  width: '100%',
                                  paddingRight: '40px',
                                  boxSizing: 'border-box',
                                  fontSize: '0.9rem',
                                  textAlign: 'right',
                                }}
                                id={`qty-${vendorId}-${item.rawmaterials_id}`}
                              />
                              <span
                                style={{
                                  position: 'absolute',
                                  right: '10px',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  fontWeight: '600',
                                  fontSize: '0.9rem',
                                  color: '#555',
                                  pointerEvents: 'none',
                                  userSelect: 'none',
                                }}
                              >
                                {unitLabel}
                              </span>
                              {qtyError && <div className="text-danger fs-7 mt-1">{qtyError}</div>}
                            </div>
                          </td>
                          <td>
                            <input
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              className="form-control text-end"
                              placeholder="Enter Amount"
                              defaultValue={vendorMaterials[vendorId]?.materials[idx]?.base_cost ?? ''}
                              id={`price-${vendorId}-${item.rawmaterials_id}`}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (/^\d*\.?\d*$/.test(val)) {
                                  handleCostChange(vendorId, idx, val);
                                }
                              }}
                            />
                            {priceError && <div className="text-danger fs-7 mt-1">{priceError}</div>}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>

                  <tfoot>
                    <tr>
                      <td colSpan={3}></td>
                      <td className="text-end">
                        <label className="fs-5 fw-bold text-black">Total Estimated Cost</label>
                      </td>
                      <td className="text-end">
                        <label className="fs-4 fw-bold text-danger">
                          ₹ {calcVendorTotal(vendorId).toFixed(2)}
                        </label>
                      </td>
                    </tr>
                  </tfoot>

                </table>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="text-end mt-3 p-2 border-top">
        <h5 className="text-danger fs-2 fw-bold">
          Grand Total : ₹ {calcGrandTotal().toFixed(2)}
        </h5>
      </div>

      <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
        <Link to={'/manage-purchase'} type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
        <button onClick={onGeneratePurchase} type="button" className="btn btn-sm btn-primary">Generate Purchase</button>

      </div>
    </>
  )


}
export default AutoPurchase;